/* tslint:disable */

/**
 */
export class ReceiptView {
    date_time?: string;
    shift_id?: number;
    driver_name?: string;
    subdriver_name?: string;
    route_name?: string;
    form_station_to?: string;
    license_plates?: string;
    total_price?: number;
    total_deposit?: number;
    collected?: number;
    shift_destroy?: number;
    vehicle_id?: number;
}
